<div class="wrapper">
  <footer class="footer">
    <div class="top-row">
      <div class="row-wrapper">
        <span class="mb-3 mb-md-0">
          {{ 'components.footer.name' | translate }}
        </span>
        <span class="mb-3 mb-md-0">
          {{ 'components.footer.phone' | translate }}
        </span>
        <span class="mb-3 mb-md-0">
          {{ 'components.footer.email' | translate }}
        </span>
      </div>
      <div class="right">
        <app-sponsor-modal />
        <span class="mb-3 mb-md-0">
          {{ 'components.footer.version' | translate }} {{version}}
        </span>
      </div>
    </div>
  </footer>
</div>
